import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 1024; // Tailwind md: 768, lg: 1024

export const useIsMobile = (): boolean => {
	const [isMobile, setIsMobile] = useState<boolean>(false);

	useEffect(() => {
		const checkScreen = () => {
			setIsMobile(
				window.innerWidth >= 320 && window.innerWidth <= MOBILE_BREAKPOINT,
			);
		};

		checkScreen(); // run on mount
		window.addEventListener("resize", checkScreen);

		return () => window.removeEventListener("resize", checkScreen);
	}, []);

	return isMobile;
};
